import type { FirmwareTrack, OwnerEntity, RobotStatus } from '@bhops/shared';
import { apiClient } from './client';

// Plan v0.3.0 §J-4 (rev 3) — typed client for the Fleet Tracker
// read-only endpoints (/api/v1/fleet/*).

export interface FirmwareVersionEntry {
  version: string;
  count: number;
  latestAppliedAt: string; // ISO
}

export interface FirmwareTrackDistribution {
  track: FirmwareTrack;
  versions: FirmwareVersionEntry[];
  unknownCount: number;
}

export interface FleetRiskSummary {
  totalManaged: number;
  oldFirmwareCount: number;
  unassignedStores: number;
  /** v0.4.0 placeholder — null until part-tracking model lands. */
  defectiveLotCount: null;
}

export interface StaleFirmwareRobot {
  id: string;
  serialShort: string | null;
  serialLong: string | null;
  status: RobotStatus;
  binaryUpdatedAt: string | null;
  ownerEntity: OwnerEntity;
  model: { id: string; code: string; displayName: string };
  deployments: Array<{
    store: { id: string; name: string; branchName: string | null };
  }>;
}

export const fleetApi = {
  async firmwareDistribution(): Promise<FirmwareTrackDistribution[]> {
    const { data } = await apiClient.get<FirmwareTrackDistribution[]>(
      '/fleet/firmware-distribution',
    );
    return data;
  },

  async riskSummary(): Promise<FleetRiskSummary> {
    const { data } = await apiClient.get<FleetRiskSummary>('/fleet/risk-summary');
    return data;
  },

  async staleFirmwareRobots(before?: string): Promise<StaleFirmwareRobot[]> {
    const { data } = await apiClient.get<StaleFirmwareRobot[]>('/fleet/stale-firmware-robots', {
      params: before ? { before } : undefined,
    });
    return data;
  },
};
